export default __webpack_public_path__ + "static/media/right-pin.6f1ec874.svg";